import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import placeholderImage from "../Navbar/CSS/Assets/Banners/150x150.png";
import "../Products/CSS/product.css";

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filters, setFilters] = useState({});
  const [availableFilters, setAvailableFilters] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory1, setSelectedSubcategory1] = useState(null);
  const [selectedSubcategory2, setSelectedSubcategory2] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const filterKeys = [
    "color",
    "size_number",
    "size_text",
    "material",
    "style",
    "pattern",
    "brand",
    "fit",
    "age_baby_products",
    "size_baby_products",
    "material_baby_products",
    "brand_baby_products",
    "notes",
    "weight_capacity",
    "service_promotion",
    "warranty_type",
    "shipped_from",
  ];

  const loadDataFromStorage = () => {
    const cat = JSON.parse(localStorage.getItem("selected_category"));
    const sub1 = JSON.parse(localStorage.getItem("selected_subcategory1"));
    const sub2 = JSON.parse(localStorage.getItem("selected_subcategory2"));
    const prods = JSON.parse(localStorage.getItem("selected_products"));

    setSelectedCategory(cat);
    setSelectedSubcategory1(sub1);
    setSelectedSubcategory2(sub2);
    setProducts(prods || []);
    setFilteredProducts(prods || []);

    const filterOptions = {};
    filterKeys.forEach((key) => (filterOptions[key] = new Set()));

    if (prods) {
      prods.forEach((product) => {
        filterKeys.forEach((key) => {
          product.variations?.[key]?.forEach((val) => {
            if (val) filterOptions[key].add(val);
          });
        });
      });
    }

    // Add dummy/default values if not present
    filterOptions["service_promotion"].add("Free Shipping");
    filterOptions["service_promotion"].add("Discount Available");

    filterOptions["warranty_type"].add("No Warranty");
    filterOptions["warranty_type"].add("1-Year Brand Warranty");

    filterOptions["shipped_from"].add("Lahore");
    filterOptions["shipped_from"].add("Karachi");

    const available = {};
    Object.entries(filterOptions).forEach(([key, set]) => {
      if (set.size > 0) available[key] = [...set];
    });

    setAvailableFilters(available);
  };

  useEffect(() => {
    loadDataFromStorage();
  }, [location]);

  useEffect(() => {
    let newFiltered = [...products];
    Object.entries(filters).forEach(([key, values]) => {
      if (values.length > 0) {
        newFiltered = newFiltered.filter((product) =>
          product.variations?.[key]?.some((val) => values.includes(val))
        );
      }
    });
    setFilteredProducts(newFiltered);
  }, [filters, products]);

  useEffect(() => {
    setFilters({});
  }, [products]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      const current = prev[key] || [];
      return {
        ...prev,
        [key]: current.includes(value)
          ? current.filter((item) => item !== value)
          : [...current, value],
      };
    });
  };

  const handleRatingFilterChange = (ratingValue) => {
    setFilters((prev) => ({
      ...prev,
      rating: [ratingValue], // Only one rating at a time
    }));
  };

  const handleViewDetails = (product) => {
    const productId = product.id;
    localStorage.setItem("selectedProductId", productId);
    navigate(`/product-details/${productId}`);
  };

  return (
    <div className="shop-page">
      <ToastContainer />

      {/* Sidebar Filter */}
      <div className="sidebar">
        <div className="filterOptions">
          {Object.entries(availableFilters).map(([key, options]) => (
            <div key={key} className="filterSection">
              <h5>{key.replaceAll("_", " ").toUpperCase()}</h5>
              <div className="filterCheckboxes">
                {options.map((val) => (
                  <label key={val} className="filterLabel">
                    <input
                      type="checkbox"
                      onChange={() => handleFilterChange(key, val)}
                      checked={filters[key]?.includes(val) || false}
                    />
                    {val}
                  </label>
                ))}
              </div>
            </div>
          ))}

          {/* ⭐ Rating Filter */}
          <div className="filterSection">
            <h5>RATING</h5>
            <div className="filterCheckboxes">
              {[5, 4, 3, 2, 1].map((star) => (
                <label key={star} className="filterLabel">
                  <input
                    type="radio"
                    name="rating"
                    onChange={() => handleRatingFilterChange(star)}
                    checked={filters.rating?.includes(star) || false}
                  />
                  {"★".repeat(star)}
                  {"☆".repeat(5 - star)}
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Products */}
      <div className="s-products-container">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => {
            const variations = product.variations || {};
            const image =
              variations.color_image?.[0] ||
              product?.product_image ||
              placeholderImage;
            const imageUrl = image.startsWith("/media")
              ? `https://dehleze.shop${image}`
              : image;
            const nameParts = product.name.split(" ");
            const displayName =
              nameParts.length > 2
                ? nameParts.slice(0, 2).join(" ") + "..."
                : product.name;

            return (
              <div key={product.id} className="s-product-card">
                <div className="s-product-image-container">
                  <img
                    src={imageUrl.replace(
                      "http://39.61.51.195:8004/",
                      "https://dehleze.shop/"
                    )}
                    alt={product.name}
                    className="s-product-image"
                  />
                </div>
                <br />
                <p className="product-name" title={product.name}>
                  {displayName}
                </p>
                <p className="price-stock text-center">
                  <span>PKR {variations.price?.[0] || product.price}</span>
                </p>

                {/* ⭐ Static 5 Stars */}
                <div className="product-stars text-center">{"★".repeat(5)}</div>

                <button
                  className="view-btn"
                  onClick={() => handleViewDetails(product)}
                >
                  View Details
                </button>
              </div>
            );
          })
        ) : (
          <div className="out-of-stock">
            <h2>No Products Found</h2>
            <p>The product you are searching for is out of stock.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsPage;
